import axios from "../utils/axios.wrapper";

export const getMealSubscriptions = async () => {
  const { data } = await axios.get("/MealSubscription");
  return data.items || data;
};

export const getActiveMealSubscriptions = async () => {
  const { data } = await axios.get("/MealSubscription/active");
  return data.items || data;
};

export const getInactiveMealSubscriptions = async () => {
  const { data } = await axios.get("/MealSubscription/inactive");
  return data.items || data;
};

export const getMealSubscriptionById = async (id) => {
  const { data } = await axios.get(`/MealSubscription/${id}`);
  return data;
};

export const createMealSubscription = async (subscription) => {
  const { data } = await axios.post("/MealSubscription/create", subscription);
  return data;
};

export const updateMealSubscription = async (id, subscription) => {
  const { data } = await axios.put(`/MealSubscription/${id}`, subscription);
  return data;
};

export const deleteMealSubscription = async (id) => {
  const { data } = await axios.delete(`/MealSubscription/${id}`);
  return data;
};

export const mealSubscriptionService = {
  getMealSubscriptions,
  getActiveMealSubscriptions,
  getInactiveMealSubscriptions,
  getMealSubscriptionById,
  createMealSubscription,
  updateMealSubscription,
  deleteMealSubscription,
};